export const abiDefault = [
    {
      type: 'constructor',
      stateMutability: 'payable',
      inputs: [
        { name: '_expirationTimestamp', type: 'uint256' },
        { name: '_expirationBuffer', type: 'uint256' },
        { name: '_beneficiary', type: 'address' },
        { name: '_oracle', type: 'address' },
        { name: '_appId', type: 'string' },
        { name: '_oracleFee', type: 'uint256' },
      ],
    },
    {
      type: 'event',
      name: 'FundsWithdrawn',
      inputs: [
        { indexed: true, name: 'recipient', type: 'address' },
        { indexed: false, name: 'amount', type: 'uint256' },
      ],
      anonymous: false,
    },
    {
      type: 'event',
      name: 'PledgeCreated',
      inputs: [
        { indexed: true, name: 'deployer', type: 'address' },
        { indexed: true, name: 'beneficiary', type: 'address' },
        { indexed: true, name: 'oracle', type: 'address' },
        { indexed: false, name: 'expirationTimestamp', type: 'uint256' },
        { indexed: false, name: 'amount', type: 'uint256' },
        { indexed: false, name: 'appId', type: 'string' },
        { indexed: false, name: 'oracleFee', type: 'uint256' },
      ],
      anonymous: false,
    },
    {
      type: 'event',
      name: 'PledgeVerified',
      inputs: [
        { indexed: false, name: 'result', type: 'bool' },
        { indexed: true, name: 'oracle', type: 'address' },
      ],
      anonymous: false,
    },
    {
      type: 'function',
      name: 'amount',
      stateMutability: 'view',
      inputs: [],
      outputs: [{ type: 'uint256' }],
    },
    {
      type: 'function',
      name: 'appId',
      stateMutability: 'view',
      inputs: [],
      outputs: [{ type: 'string' }],
    },
    {
      type: 'function',
      name: 'beneficiary',
      stateMutability: 'view',
      inputs: [],
      outputs: [{ type: 'address' }],
    },
    {
      type: 'function',
      name: 'deployer',
      stateMutability: 'view',
      inputs: [],
      outputs: [{ type: 'address' }],
    },
    {
      type: 'function',
      name: 'expirationBuffer',
      stateMutability: 'view',
      inputs: [],
      outputs: [{ type: 'uint256' }],
    },
    {
      type: 'function',
      name: 'expirationTimestamp',
      stateMutability: 'view',
      inputs: [],
      outputs: [{ type: 'uint256' }],
    },
    {
      type: 'function',
      name: 'oracle',
      stateMutability: 'view',
      inputs: [],
      outputs: [{ type: 'address' }],
    },
    {
      type: 'function',
      name: 'oracleFee',
      stateMutability: 'view',
      inputs: [],
      outputs: [{ type: 'uint256' }],
    },
    {
      type: 'function',
      name: 'result',
      stateMutability: 'view',
      inputs: [],
      outputs: [{ type: 'bool' }],
    },
    {
      type: 'function',
      name: 'verified',
      stateMutability: 'view',
      inputs: [],
      outputs: [{ type: 'bool' }],
    },
    {
      type: 'function',
      name: 'verifyPledge',
      stateMutability: 'nonpayable',
      inputs: [{ name: '_result', type: 'bool' }],
      outputs: [],
    },
    {
      type: 'function',
      name: 'withdraw',
      stateMutability: 'nonpayable',
      inputs: [],
      outputs: [],
    },
  ] as const;
